module.exports = __webpack_public_path__ + "media/images/Candle-Holder_3b-988d74f77081f447c04dc2e879127afe.gif";